import "isomorphic-fetch";
import React from "react";
import * as ReactJSXDevRuntime from "react/jsx-dev-runtime";
import * as ReactJSXRuntime from "react/jsx-runtime";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
if (typeof localStorage === "object") {
  try {
    localStorage.setItem("mod", "mod");
    localStorage.removeItem("mod");
  } catch (e) {
    Object.defineProperty(
      window,
      "localStorage",
      new function() {
        var aKeys = [], oStorage = {};
        Object.defineProperty(oStorage, "getItem", {
          value: function(sKey) {
            return sKey ? this[sKey] : null;
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, "key", {
          value: function(nKeyId) {
            return aKeys[nKeyId];
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, "setItem", {
          value: function(sKey, sValue) {
            if (!sKey) {
              return;
            }
            document.cookie = escape(sKey) + "=" + escape(sValue) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, "length", {
          get: function() {
            return aKeys.length;
          },
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, "removeItem", {
          value: function(sKey) {
            if (!sKey) {
              return;
            }
            document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, "clear", {
          value: function() {
            if (!aKeys.length) {
              return;
            }
            for (var sKey in aKeys) {
              document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
            }
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        this.get = function() {
          var iThisIndx;
          for (var sKey in oStorage) {
            iThisIndx = aKeys.indexOf(sKey);
            if (iThisIndx === -1) {
              oStorage.setItem(sKey, oStorage[sKey]);
            } else {
              aKeys.splice(iThisIndx, 1);
            }
            delete oStorage[sKey];
          }
          for (aKeys; aKeys.length > 0; aKeys.splice(0, 1)) {
            oStorage.removeItem(aKeys[0]);
          }
          for (var aCouple, iKey, nIdx = 0, aCouples = document.cookie.split(/\s*;\s*/); nIdx < aCouples.length; nIdx++) {
            aCouple = aCouples[nIdx].split(/\s*=\s*/);
            if (aCouple.length > 1) {
              oStorage[iKey = unescape(aCouple[0])] = unescape(aCouple[1]);
              aKeys.push(iKey);
            }
          }
          return oStorage;
        };
        this.configurable = false;
        this.enumerable = true;
      }()
    );
    console.log("Your web browser does not support storing settings locally.");
  }
}
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
if (React && typeof React.createElement === "function") {
  const patchFlag = "__TABEO_DEFAULT_PROPS_PATCHED__";
  const mergeDefaultProps = (type, props) => {
    if (!type || !type.defaultProps) {
      return props;
    }
    const defaults = type.defaultProps;
    let nextProps = props;
    for (const key in defaults) {
      if (!nextProps || nextProps[key] === void 0) {
        if (nextProps === props) {
          nextProps = props ? { ...props } : {};
        }
        nextProps[key] = defaults[key];
      }
    }
    return nextProps;
  };
  if (!React[patchFlag]) {
    const originalCreateElement = React.createElement;
    React.createElement = function(type, props, ...children) {
      return originalCreateElement(
        type,
        mergeDefaultProps(type, props),
        ...children
      );
    };
    const patchJSXFactory = (runtime, methodName) => {
      if (!runtime || typeof runtime[methodName] !== "function") {
        return;
      }
      const originalFactory = runtime[methodName];
      runtime[methodName] = function(type, props, ...rest) {
        return originalFactory(type, mergeDefaultProps(type, props), ...rest);
      };
    };
    try {
      patchJSXFactory(ReactJSXRuntime, "jsx");
      patchJSXFactory(ReactJSXRuntime, "jsxs");
      patchJSXFactory(ReactJSXDevRuntime, "jsxDEV");
    } catch (e) {
    }
    React[patchFlag] = true;
  }
}
